import { DateTime } from 'luxon';
import { Column } from 'react-table';
import { Box, styled, Typography } from '@mui/material';
import { CalendarModes, dayAccessors } from '../calendar-grid.types';

export const getDateColumns = <DateCellData extends object>(
  calendarMode: CalendarModes,
  startDate: DateTime,
  cellFn: ({ value }: { value: DateCellData }) => JSX.Element,
  headerFn?: (...args: any[]) => JSX.Element
): Column[] => {
  const daysInMonth = startDate.daysInMonth;
  let dateColumns: Column[] = [];

  const createDayColumns = (
    daysInMonth: number,
    cellFn: ({ value }: { value: DateCellData }) => JSX.Element,
    headerFn: (date: DateTime) => JSX.Element
  ) => {
    const columns: Column[] = [];
    for (let i = 1; i <= daysInMonth; i++) {
      const date = startDate.set({ day: i });
      columns.push({
        width: '30px',
        maxWidth: 1,
        accessor: dayAccessors[i - 1],
        Cell: ({ value }: { value: DateCellData }) => cellFn({ value }),
        Header: headerFn(date),
      });
    }
    return columns;
  };

  if (!headerFn) {
    headerFn = (date: DateTime) => {
      return (
        <StyledBox>
          <HeaderTypography variant="inherit">{date.toFormat('EEE')}</HeaderTypography>
          <HeaderTypography variant="inherit">{date.day}</HeaderTypography>
        </StyledBox>
      );
    };
  }

  if (calendarMode === 'month') {
    dateColumns = createDayColumns(daysInMonth, cellFn, headerFn);
    return dateColumns;
  }

  throw new Error(`Unsupported calendar mode: ${calendarMode}`);
};

const StyledBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
}));

const HeaderTypography = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  textAlign: 'center',
  color: theme.palette.lwPrimaryAccentDark?.[40] ?? 'lightblue',
}));
